import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { SelectItem } from 'primeng/primeng';
import { StoreCommonService } from '../../../../../services/store/store-common.service';

@Component({
  selector: 'app-store-group-details-form',
  templateUrl: './store-group-details-form.component.html',
  styles: ['label.required:after {top: 0}']
})
export class StoreGroupDetailsFormComponent implements OnInit {

  @Input() editingElement: any;
  @Output() onAddElement: EventEmitter<any> = new EventEmitter<any>();

  addEditFormDetails: FormGroup;
  store_items: SelectItem[] = [{value: null, label: ''}];
  selected_store: any;

  fields: any;
  public invalidSubmit: boolean;

  refreshList() {
    this.svc.list_store.forEach(s => {
      this.store_items.push({
        value: s.id,
        label: s.name
      })}, this)
  }

  constructor(
    public svc: StoreCommonService,
    private fb: FormBuilder ) {
  }

  ngOnInit(): void {

    this.addEditFormDetails = this.fb.group({
      'sales_network_id': new FormControl(this.editingElement['sales_network_id'])
    });

    this.svc.getStoreGroupDetailFields().subscribe(res => {
      this.fields = res;
    });

    if (!this.svc.list_store || this.svc.list_store.length === 0) {
      this.svc.getList().subscribe(() => {
        this.refreshList();
      });
    } else {
      this.refreshList();
    }
  }

  saveOrUpdate(): void {

    if (!this.addEditFormDetails.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;

    let newData = {};
    newData['store_group_id'] = this.editingElement.store_group_id;
    newData['store_id'] = this.addEditFormDetails.value.sales_network_id;
    this.onAddElement.emit(newData);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/store/store-group/store-group-details/store-group-details-form.component.ts